// extracted by mini-css-extract-plugin
module.exports = {"_inputstyle":"InputStyle__inputstyle_3865g white"};